var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 66,
    viewBox: "0 0 53 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2221",
    "data-name": "Rectangle 2221",
    width: 53,
    height: 66,
    transform: "translate(-0.339 0.264)",
    fill: "#ffbd00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10357",
    "data-name": "Group 10357",
    transform: "translate(0.339 -0.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10356",
    "data-name": "Group 10356",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27732",
    "data-name": "Path 27732",
    d: "M16.529,26.446h3.306a3.306,3.306,0,1,0,0-6.612H16.529a3.306,3.306,0,0,0,0,6.612m0,6.612a3.306,3.306,0,1,0,0,6.612H36.363a3.306,3.306,0,1,0,0-6.612ZM52.892,22.933a3.739,3.739,0,0,0-.207-.877v-.309a2.937,2.937,0,0,0-.621-.912L32.229,1A3,3,0,0,0,31.3.361a.829.829,0,0,0-.3,0A3.119,3.119,0,0,0,29.924,0H9.917A9.921,9.921,0,0,0,0,9.917V56.2a9.921,9.921,0,0,0,9.917,9.917H42.975A9.921,9.921,0,0,0,52.892,56.2V22.933M33.058,11.279l8.555,8.555h-5.25a3.307,3.307,0,0,1-3.306-3.306ZM46.281,56.2A3.307,3.307,0,0,1,42.975,59.5H9.917A3.307,3.307,0,0,1,6.612,56.2V9.917A3.307,3.307,0,0,1,9.917,6.612H26.446v9.917a9.921,9.921,0,0,0,9.917,9.917h9.917Zm-9.917-9.917H16.529a3.306,3.306,0,0,0,0,6.612H36.363a3.306,3.306,0,0,0,0-6.612",
    transform: "translate(0 0)",
    fill: "#ffbd00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon3);
export default __webpack_public_path__ + "static/media/social_icon3.314db0ec8b08d567af40f702b24f4e49.svg";
export { ForwardRef as ReactComponent };